import { Comment } from '../types'

export const sortCommentsFromNewestCompareFn = (comment1: Comment, comment2: Comment) => {
  const timestamp1 = comment1.timestamp
  const timestamp2 = comment2.timestamp

  if (!timestamp2) return -1
  if (!timestamp1) return 1
  return timestamp2 - timestamp1
}

export const sortCommentsFromNewest = (comments: Comment[]) => {
  return [...comments].sort(sortCommentsFromNewestCompareFn)
}

export const sortCommentsFromOldest = (comments: Comment[]) => {
  return [...comments].sort((commentA, commentB) =>
    sortCommentsFromNewestCompareFn(commentB, commentA)
  )
}
